import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Button, Grid, Box } from '@mui/material';

QueueNextButton.propTypes = {};

export default function QueueNextButton() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const section = location.pathname.split('/')[3];

  const invoicesInQueue = JSON.parse(localStorage.getItem('selectedInvoices'));
  const invoicesLeft = invoicesInQueue?.length;
  const numericId = Number(id);
  const currentIndex = invoicesInQueue?.indexOf(numericId);

  const goToPreviousInvoice = () => {
    if (currentIndex > 0) {
      const prevId = invoicesInQueue[currentIndex - 1];
      navigate(`/dashboard/invoicing/${section}/${prevId}`);
    }
  };
  const goToNextInvoice = () => {
    if (currentIndex > -1 && currentIndex < invoicesLeft - 1) {
      const nextId = invoicesInQueue[currentIndex + 1];
      navigate(`/dashboard/invoicing/${section}/${nextId}`);
    }
  };

  return (
    <>
      <Box>
        {currentIndex > 0 && (
          <Button color="secondary" sx={{ textDecoration: 'underline' }} onClick={goToPreviousInvoice}>
            Prev {`(${currentIndex})`}
          </Button>
        )}

        {currentIndex > -1 && currentIndex < invoicesLeft - 1 && (
          <Button color="secondary" sx={{ textDecoration: 'underline' }} onClick={goToNextInvoice}>
            Next {`(${invoicesLeft - currentIndex - 1})`}
          </Button>
        )}
      </Box>
    </>
  );
}
